import React from 'react'
import moment from 'moment'
import axios from 'axios'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import MessageCard from '../comms/message_card'
import EmailContentModal from '../comms/email_content_modal'

class ActivityStreamItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false, viewingEmail: null }
    this.onViewEmail = this.onViewEmail.bind(this)
  }

  toggleExpanded = () => {
    this.setState((prev) => ({isExpanded: !prev.isExpanded}))
  }

  renderComment() {
    const comment = this.props.item
    const commenterName = comment.commenter_name
    const isSystem = !commenterName

    let content = comment.name
    const canContract = content.startsWith('(via mail') || content.startsWith('(via WhatsApp')
    let hasOverflow = false

    if (canContract) {
      const lines = content.split('\n')
      if (lines.length > 2) {
        hasOverflow = true
        if (!this.state.isExpanded) {
          content = lines.slice(0, 2).join('\n')
        }
      }
    }

    content = content.replace(/\n/g, '<br/>')
    content = content.replace(/\[(.+?)\]\((.+?)\)/gi, "<a href='$2' target='_blank'>$1</a>")

    const m = comment.time ? moment(comment.time) : null

    return (
      <div className="mb-2 rounded-[10px] border border-border bg-card px-4 py-3">
        <div className="flex gap-2.5">
          <div className="shrink-0">
            {comment.profile_picture_url ?
              <img
                width="32" height="32"
                className="size-8 rounded-full object-cover"
                src={comment.profile_picture_url}
                title={commenterName}
              />
            :
              <div className={cn(
                'flex size-8 items-center justify-center rounded-full text-xs font-semibold',
                isSystem ? 'bg-muted text-muted-foreground' : 'bg-primary/10 text-primary'
              )}>
                {isSystem ? '⚙' : (commenterName || '?').charAt(0).toUpperCase()}
              </div>
            }
          </div>
          <div className="min-w-0 flex-1">
            <div className="mb-0.5 flex items-center gap-2">
              {commenterName &&
                <span className="text-[12.5px] font-semibold text-foreground">
                  {commenterName}
                </span>
              }
              {!commenterName &&
                <span className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-px text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">System</span>
              }
              {m &&
                <span className="text-[11px] font-medium text-muted-foreground">
                  {m.format('D MMM YYYY')} · {m.format('HH:mm')}
                </span>
              }
            </div>
            <div
              className={cn('[overflow-wrap:anywhere]', isSystem ? 'text-muted-foreground' : 'text-foreground')}
              dangerouslySetInnerHTML={{__html: content}}
            />
            {hasOverflow &&
              <Button variant="link" size="sm" className="mt-0.5 h-auto p-0 text-[11px]" onClick={this.toggleExpanded}>
                {this.state.isExpanded ? 'Show less' : 'Show more'}
              </Button>
            }
          </div>
        </div>
      </div>
    )
  }

  onViewEmail(item) {
    axios.get(`/api/sales/outbound_mails/${item.id}`).then((response) => {
      this.setState({ viewingEmail: { ...item, contents: response.data.contents || [] } })
    })
  }

  renderComm() {
    return (
      <div className="mb-2">
        <MessageCard item={this.props.item} isLast={true} onViewEmail={this.onViewEmail} />
      </div>
    )
  }

  render() {
    const { item } = this.props

    return (
      <React.Fragment>
        {item._stream_type === 'comm' ? this.renderComm() : this.renderComment()}
        {this.state.viewingEmail &&
          <EmailContentModal
            contents={this.state.viewingEmail.contents}
            subject={this.state.viewingEmail.subject}
            onClose={() => this.setState({ viewingEmail: null })}
          />
        }
      </React.Fragment>
    )
  }
}

export default ActivityStreamItem
